export default __webpack_public_path__ + "static/media/lifemarket_en.8ebc15c0.png";